/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable no-template-curly-in-string */

import React, { useContext, useEffect } from 'react';

import { I18nContext } from '../contexts/I18nProvider';

import Spinner from '../components/loaders/Spinner';

const Weddings = () => {
  const [iframeLoading, setIframeLoading] = React.useState(false);
  const { setActualComponent } = useContext(I18nContext);
  const TOKEN_IFRAMES = process.env.REACT_APP_TOKEN_IFRAMES_WEDDINGS;

  const handleIframeLoad = () => {
    console.log('iframe loaded');
    setIframeLoading(true);
  };

  useEffect(() => {
    setActualComponent('weddings');
  }, []);

  return (
    <>
      {!iframeLoading && <Spinner />}

      <iframe
        style={
          iframeLoading
            ? { opacity: 1, height: '100%', minHeight: '100vh' }
            : { opacity: 0, height: '0', minHeight: '50vh' }
        }
        onLoad={handleIframeLoad}
        className='weddings'
        src={TOKEN_IFRAMES}
        async
      />
    </>
  );
};

export default Weddings;
